import React, { PureComponent } from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import PropTypes from 'prop-types';

import styles from './index.css';

import { LazyImg } from '@ifeng-fe/ui_pc_lazyLoad';
import { formatImage } from '@ifeng-fe/public_method';

import { getSurveyData, postSurvey, getRestaurantInfo } from '../../../../services/api';

import { Dialog } from '../modal';

import ArticleDetail from '../articleDetail';

class RestaurantItem extends PureComponent {
    static propTypes = {
        data: PropTypes.object,
        callbackIndex: PropTypes.number,
    };

    state = {
        vote: 0,
        questionid: '',
        optionId: '',
    };

    componentDidMount = () => {
        this.asyncGetSurveyData();
    };

    asyncGetSurveyData = async () => {
        const {
            data: { surveyId },
            callbackIndex,
        } = this.props;

        if (surveyId) {
            try {
                const res = await getSurveyData(surveyId, callbackIndex);

                if (res && res.ifsuccess === 1) {
                    const { data } = res;
                    const questionid = data.result[0] && data.result[0].resultArray.questionid;
                    const vote = data.result[0] && data.result[0].resultArray.option[0].num;
                    const optionId = data.result[0] && data.result[0].resultArray.option[0].itemid;

                    // console.log({ vote, questionid, optionId });
                    this.setState({ vote, questionid, optionId });
                } else {
                    alert(res.msg || '获取失败');
                }
            } catch (error) {
                alert(error.message);
            }
        }
    };

    handlePostVote = async () => {
        const {
            data: { surveyId },
        } = this.props;

        if (surveyId) {
            const { questionid, optionId } = this.state;

            const sur = `sur[${questionid}][]=${optionId}`;

            try {
                const res = await postSurvey(surveyId, sur);

                if (res && res.ifsuccess) {
                    this.asyncGetSurveyData();
                } else {
                    alert(res.msg || '点赞失败');
                }
            } catch (error) {
                alert(error.message);
            }
        } else {
            alert('准备中');
        }
    };

    handeClick = async () => {
        const { id } = this.props.data;

        if (id) {
            try {
                const res = await getRestaurantInfo(id);

                // console.log(res);
                if (res && res.code === 0) {
                    Dialog.show({
                        title: '餐厅详情',
                        content: <ArticleDetail className={styles.articleDetail} content={res.data} />,
                    });
                } else {
                    alert(res.msg || '获取文章详情失败');
                }
            } catch (error) {
                alert(error.message);
            }
        } else {
            alert('暂无详情');
        }
    };

    render() {
        const {
            data: { index, posterUrl, name, summary },
            callbackIndex,
        } = this.props;
        const { vote } = this.state;

        const loadImgUrl =
            'data:image/svg+xml;utf8,<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="349" height="196"><text x="120" y="108" fill="%23dcdcdc" style="font-size: 28px;">鳳凰新聞</text></svg>';

        return (
            <div className={styles.restaurantItem} style={{ marginRight: (callbackIndex + 1) % 4 === 0 ? 0 : 10 }}>
                <div className={styles.number}>NO.{index}</div>
                <div className={styles.poster} onClick={this.handeClick}>
                    {posterUrl ? (
                        <LazyImg
                            placeholder={loadImgUrl}
                            src={formatImage(posterUrl, 320, 180)}
                            width="320"
                            height="180"
                        />
                    ) : (
                        <img src={loadImgUrl} alt="" />
                    )}
                </div>
                <div className={styles.title}>{name}</div>
                <div className={styles.summary}>{summary}</div>
                <div className={styles.vote}>{vote}票</div>
                <div className={styles.voteBtn} onClick={this.handlePostVote}>
                    点赞
                </div>
            </div>
        );
    }
}

export default errorBoundary(RestaurantItem);
